import React, { useEffect } from "react";
import HomeAbout from "../Components/HomeInfo/HomeAbout";
import ServicesSlideshow from "../Components/ServicesSlideshow/ServicesSlideshow";
import AproachInfo from "../Components/AproachInfo/AproachInfo";
import NewHome from "../Components/HomeInfo/NewHome";
import observeAnimations from "../Components/Utils/Utils";
const Home = () => {
  useEffect(() => {
    observeAnimations(); // Initialize scroll animations
  }, []);

  return (
    <div>
      <div>
        <NewHome />
      </div>
      <div>
        <HomeAbout />
      </div>
      <div className="animate-on-scroll">
        <ServicesSlideshow />
      </div>
      <div className="animate-on-scroll">
        <AproachInfo />
      </div>
    </div>
  );
};

export default Home;
